import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import HumanResourcesDashboard from "./HumanResourcesDashboard";
import AppHeader from "components/Header/AppHeader";
import MDBox from "components/MDBox";
function HumanResourcesDashboardPage({ subcategoryToken }) {
  return (
    <DashboardLayout>
      <MDBox
        sx={{
          display: {
            xs: "block",
            sm: "block",
            md: "none",
          },
        }}
      >
        <AppHeader />
      </MDBox>
      <HumanResourcesDashboard subcategoryToken={subcategoryToken} />
    </DashboardLayout>
  );
}

export default HumanResourcesDashboardPage;
